import axios from "axios";
import { storageKeys } from "../Constants/storage.key";

const api = axios.create({
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    "Access-Control-Allow-Credentials": true,
  },
  crossDomain: true,
});

api.interceptors.request.use(async (config) => {
  if (
    !config.url.toLowerCase().includes("/auth/login") &&
    !config.url.toLowerCase().includes("/auth/password") &&
    !config.url.toLowerCase().includes("/authorized/login")
  ) {
    let token = recoverToken();

    if (process.env.ENVIRONMENT === "TEST") {
      token = "bearer " + process.env.REACT_APP_MOCK_TOKEN; //mock
    }

    if (token) {
      config.headers.Authorization = token;
    }
  }

  if (config.url.toLowerCase().includes("domain")) {
    //const host = document.location.host;
    // TODO: Alterar para PRD
    console.warn("TODO: Dominio setado a força. Remover!");
    const host = "ofv2.dev.thetos.com.br";
    //const host = document.location.host;
    console.log(`Host que está acessando: %c${host}`, "color:#55AAFF");

    config.headers["domainName"] = host;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (response) => {

    
    if (
      response?.response?.status === 401
    ) {
      window.location = "/#/";
      return;
    }

    return response;
  }
);

const recoverToken = () => {
  const token = localStorage.getItem(storageKeys.access_and_token);

  if (token) {
    const parsed = JSON.parse(token);
    return "bearer " + parsed.token;
  }
  return null;
};

export default api;
